// import modal from "antd/lib/modal";
import React from "react";

const CertificationItem = (props: any) => {
  const { certification } = props;
  // const html = certification.content.replaceAll(`width="100%"`, `width="50%"`);

  // const config = {
  //   closable: true,
  //   maskClosable: true,
  //   width: 1000,
  //   icon: null,
  //   content: (
  //     <div
  //       dangerouslySetInnerHTML={{
  //         __html: html,
  //       }}></div>
  //   ),
  //   centered: true,
  // };

  return (
    // <Row align="middle" justify="center">
    <div
      className="certification-item-wrapper"
      // onClick={() => {
      //   modal.info(config);

      //   setTimeout(() => {
      //     if (document.getElementsByClassName("ant-modal-wrap")[0]) {
      //       document
      //         .getElementsByClassName("ant-modal-wrap")[0]
      //         .scrollTo(0, 0);
      //     }
      //   }, 1000);
      // }}
    >
      {/* <Col>
        <Row align="middle" justify="center"> */}
      <div className="certification-item-img">
        <img src={certification.img.path} alt="" />
      </div>
      {/* </Row>
        <Row align="middle" justify="center"> */}
      <span className="sub-content certification-item-name">
        {certification.name}
      </span>
      {/* </Row>
      </Col> */}
    </div>
    // </Row>
  );
};

export default CertificationItem;
